export function pagesToTechnicalSheets(pages, sides) {
  const n = Number(pages || 0);
  if (!n) return 0;
  return sides === "double" ? Math.ceil(n / 2) : n;
}

export function totalKnownPages(entries = []) {
  return entries.reduce((acc, e) => acc + (typeof e.pages === "number" ? e.pages : 0), 0);
}

export function hasFinish(opts, slugPart) {
  return Array.isArray(opts?.finishes) && opts.finishes.some((x) => String(x).includes(slugPart));
}

export function buildKapeiRecommendations({ entries = [], opts = {} }) {
  const pages = totalKnownPages(entries);
  const sheets = pagesToTechnicalSheets(pages, opts.sides);
  const recommendations = [];

  if (pages > 0 && hasFinish(opts, "grapado") && sheets > 25) {
    recommendations.push({
      type: "warning",
      key: "stapling-too-thick",
      title: "Mejor encuadernar",
      message: `Este documento tiene ${pages} páginas y no es recomendable graparlo. Te recomendamos encuadernarlo.`,
    });
  }

  if (pages >= 80 && !hasFinish(opts, "encuadernacion") && !hasFinish(opts, "espiral")) {
    recommendations.push({
      type: "suggestion",
      key: "suggest-binding",
      title: "¿Quieres encuadernarlo?",
      message: `Este documento tiene ${pages} páginas. Si quieres, podemos prepararlo encuadernado.`,
    });
  }

  if (hasFinish(opts, "carton-pluma") && opts.paper !== "cartulina-brillo-350g") {
    recommendations.push({
      type: "auto",
      key: "foam-board-paper",
      title: "Material ajustado",
      message: "Para montar en cartón pluma usamos cartulina brillo 350 g.",
      action: {
        type: "set_option",
        field: "paper",
        value: "cartulina-brillo-350g",
      },
    });
  }

  return recommendations;
}
